import React from 'react';
import { FadeInView } from '../ui/FadeInView';
export function TomosSection() {
  return <>
      <section className="py-16 md:py-24 px-4 bg-[#F5F0E8] text-center relative overflow-hidden" data-id="element-294">
        <div className="max-w-5xl mx-auto relative z-10" data-id="element-295">
          <FadeInView data-id="element-296">
            <h2 className="text-4xl md:text-6xl font-bold text-[#1B4332] mb-6 leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-297">
              ¿Qué incluye exactamente el MegaPack?
            </h2>
            <p className="text-2xl font-medium text-[#D4A853] mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-298">
              El sistema completo para adelgazar con Airfryer
            </p>
            <p className="text-lg text-[#2D5016]/80 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-299">
              Este megapack incluye 6 tomos diseñados paso a paso.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left" data-id="element-300">
              {/* TOMO 1 */}
              <div className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-301">
                <div className="bg-[#2D5016]/10 text-[#2D5016] font-medium text-xs px-4 py-1.5 rounded-full inline-block mb-4 tracking-widest uppercase" data-id="element-302">
                  Tomo 1
                </div>
                <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-303">
                  Fundamentos para adelgazar con Airfryer
                </h3>
                <p className="text-[#2D5016]/80 font-medium mb-4 text-base" data-id="element-304">
                  Aprenderás:
                </p>
                <ul className="space-y-3 text-[#1B4332] text-base" data-id="element-305">
                  <li className="flex items-start gap-3" data-id="element-306">
                    <span className="text-[#D4A853] mt-1" data-id="element-307">•</span> cómo funciona
                    la airfryer
                  </li>
                  <li className="flex items-start gap-3" data-id="element-308">
                    <span className="text-[#D4A853] mt-1" data-id="element-309">•</span> por qué ayuda
                    a reducir calorías
                  </li>
                  <li className="flex items-start gap-3" data-id="element-310">
                    <span className="text-[#D4A853] mt-1" data-id="element-311">•</span> cómo
                    estructurar comidas saludables
                  </li>
                  <li className="flex items-start gap-3" data-id="element-312">
                    <span className="text-[#D4A853] mt-1" data-id="element-313">•</span> errores
                    comunes al intentar adelgazar
                  </li>
                </ul>
              </div>

              {/* TOMO 2 */}
              <div className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-314">
                <div className="bg-[#2D5016]/10 text-[#2D5016] font-medium text-xs px-4 py-1.5 rounded-full inline-block mb-4 tracking-widest uppercase" data-id="element-315">
                  Tomo 2
                </div>
                <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-316">
                  Recetas saludables para el día a día
                </h3>
                <p className="text-[#2D5016]/80 font-medium mb-2 text-base" data-id="element-317">
                  Incluye recetas fáciles como:
                </p>
                <p className="text-[#1B4332]/70 italic mb-4 text-sm leading-relaxed" data-id="element-318">
                  pollo crujiente saludable • salmón con verduras • chips de
                  boniato • verduras crujientes
                </p>
                <ul className="space-y-3 text-[#1B4332] font-medium text-base" data-id="element-319">
                  <li className="flex items-center gap-3" data-id="element-320">
                    <span className="text-[#D4A853]" data-id="element-321">•</span> rápidas
                  </li>
                  <li className="flex items-center gap-3" data-id="element-322">
                    <span className="text-[#D4A853]" data-id="element-323">•</span> económicas
                  </li>
                  <li className="flex items-center gap-3" data-id="element-324">
                    <span className="text-[#D4A853]" data-id="element-325">•</span> bajas en calorías
                  </li>
                </ul>
              </div>

              {/* TOMO 3 */}
              <div className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-326">
                <div className="bg-[#2D5016]/10 text-[#2D5016] font-medium text-xs px-4 py-1.5 rounded-full inline-block mb-4 tracking-widest uppercase" data-id="element-327">
                  Tomo 3
                </div>
                <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-328">
                  Planificación de comidas para adelgazar
                </h3>
                <p className="text-[#2D5016]/80 font-medium mb-4 text-base" data-id="element-329">
                  Aprenderás:
                </p>
                <ul className="space-y-3 text-[#1B4332] text-base" data-id="element-330">
                  <li className="flex items-start gap-3" data-id="element-331">
                    <span className="text-[#D4A853] mt-1" data-id="element-332">•</span> organizar tu
                    semana
                  </li>
                  <li className="flex items-start gap-3" data-id="element-333">
                    <span className="text-[#D4A853] mt-1" data-id="element-334">•</span> evitar
                    improvisar comidas poco saludables
                  </li>
                  <li className="flex items-start gap-3" data-id="element-335">
                    <span className="text-[#D4A853] mt-1" data-id="element-336">•</span> crear menús
                    equilibrados
                  </li>
                </ul>
              </div>

              {/* TOMO 4 */}
              <div className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-337">
                <div className="bg-[#2D5016]/10 text-[#2D5016] font-medium text-xs px-4 py-1.5 rounded-full inline-block mb-4 tracking-widest uppercase" data-id="element-338">
                  Tomo 4
                </div>
                <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-339">
                  Batch cooking con Airfryer
                </h3>
                <p className="text-[#2D5016]/80 font-medium mb-4 text-base" data-id="element-340">
                  Descubre cómo preparar varias comidas en una sola sesión.
                </p>
                <ul className="space-y-3 text-[#1B4332] text-base" data-id="element-341">
                  <li className="flex items-start gap-3" data-id="element-342">
                    <span className="text-[#D4A853] mt-1" data-id="element-343">•</span> ahorrar
                    tiempo
                  </li>
                  <li className="flex items-start gap-3" data-id="element-344">
                    <span className="text-[#D4A853] mt-1" data-id="element-345">•</span> tener comidas
                    saludables listas
                  </li>
                  <li className="flex items-start gap-3" data-id="element-346">
                    <span className="text-[#D4A853] mt-1" data-id="element-347">•</span> evitar comida
                    rápida
                  </li>
                </ul>
              </div>

              {/* TOMO 5 */}
              <div className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-348">
                <div className="bg-[#2D5016]/10 text-[#2D5016] font-medium text-xs px-4 py-1.5 rounded-full inline-block mb-4 tracking-widest uppercase" data-id="element-349">
                  Tomo 5
                </div>
                <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-350">
                  Postres saludables en Airfryer
                </h3>
                <p className="text-[#2D5016]/80 font-medium mb-2 text-base" data-id="element-351">
                  Porque adelgazar no significa renunciar al dulce.
                </p>
                <p className="text-[#2D5016]/80 font-medium mb-2 text-base" data-id="element-352">
                  Recetas como:
                </p>
                <p className="text-[#1B4332]/70 italic text-sm leading-relaxed" data-id="element-353">
                  brownies saludables • tartas ligeras • snacks dulces sin culpa
                </p>
              </div>

              {/* TOMO 6 */}
              <div className="bg-[#FAF7F2] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-354">
                <div className="bg-[#2D5016]/10 text-[#2D5016] font-medium text-xs px-4 py-1.5 rounded-full inline-block mb-4 tracking-widest uppercase" data-id="element-355">
                  Tomo 6
                </div>
                <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-356">
                  Mantener resultados sin efecto rebote
                </h3>
                <p className="text-[#2D5016]/80 font-medium mb-4 text-base" data-id="element-357">
                  Aprenderás:
                </p>
                <ul className="space-y-3 text-[#1B4332] text-base" data-id="element-358">
                  <li className="flex items-start gap-3" data-id="element-359">
                    <span className="text-[#D4A853] mt-1" data-id="element-360">•</span> mantener
                    hábitos
                  </li>
                  <li className="flex items-start gap-3" data-id="element-361">
                    <span className="text-[#D4A853] mt-1" data-id="element-362">•</span> evitar
                    recuperar peso
                  </li>
                  <li className="flex items-start gap-3" data-id="element-363">
                    <span className="text-[#D4A853] mt-1" data-id="element-364">•</span> convertir la
                    alimentación saludable en un estilo de vida
                  </li>
                </ul>
              </div>
            </div>
          </FadeInView>
        </div>
      </section>

      {/* BEFORE / AFTER SECTION */}
      <section className="py-16 md:py-24 px-4 bg-[#1B4332] text-[#FAF7F2] text-center relative overflow-hidden" data-id="element-365">
        <div className="max-w-5xl mx-auto relative z-10" data-id="element-366">
          <FadeInView data-id="element-367">
            <h2 className="text-4xl md:text-6xl font-bold mb-12 text-[#D4A853]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-368">
              Antes vs Después
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-369">
              <div className="bg-[#FAF7F2]/5 border border-[#FAF7F2]/10 rounded-3xl p-8 md:p-10 text-left" data-id="element-370">
                <h3 className="text-3xl font-bold text-[#FAF7F2]/60 mb-8 flex items-center gap-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-371">
                  <span className="text-xl" data-id="element-372">✕</span> Antes
                </h3>
                <ul className="space-y-6 text-xl text-[#FAF7F2]/70" data-id="element-373">
                  <li className="flex items-center gap-4" data-id="element-374">
                    <span className="text-[#FAF7F2]/40 text-sm" data-id="element-375">✕</span> dietas
                    difíciles
                  </li>
                  <li className="flex items-center gap-4" data-id="element-376">
                    <span className="text-[#FAF7F2]/40 text-sm" data-id="element-377">✕</span> comida
                    aburrida
                  </li>
                  <li className="flex items-center gap-4" data-id="element-378">
                    <span className="text-[#FAF7F2]/40 text-sm" data-id="element-379">✕</span> poco
                    tiempo para cocinar
                  </li>
                  <li className="flex items-center gap-4" data-id="element-380">
                    <span className="text-[#FAF7F2]/40 text-sm" data-id="element-381">✕</span>{' '}
                    frustración constante
                  </li>
                </ul>
              </div>

              <div className="bg-[#2D5016] border border-[#D4A853]/30 rounded-3xl p-8 md:p-10 text-left shadow-2xl relative overflow-hidden" data-id="element-382">
                <h3 className="text-3xl font-bold text-[#D4A853] mb-8 flex items-center gap-4" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-383">
                  <span className="text-xl" data-id="element-384">•</span> Después
                </h3>
                <ul className="space-y-6 text-xl text-[#FAF7F2] font-medium" data-id="element-385">
                  <li className="flex items-center gap-4" data-id="element-386">
                    <span className="text-[#D4A853]" data-id="element-387">•</span> comidas deliciosas
                  </li>
                  <li className="flex items-center gap-4" data-id="element-388">
                    <span className="text-[#D4A853]" data-id="element-389">•</span> menos calorías
                  </li>
                  <li className="flex items-center gap-4" data-id="element-390">
                    <span className="text-[#D4A853]" data-id="element-391">•</span> organización
                    semanal
                  </li>
                  <li className="flex items-center gap-4" data-id="element-392">
                    <span className="text-[#D4A853]" data-id="element-393">•</span> hábitos
                    sostenibles
                  </li>
                </ul>
              </div>
            </div>
          </FadeInView>
        </div>
      </section>
    </>;
}